var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 353,
    height: 209,
    viewBox: "0 0 353 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.22 6.014h40.56a.72.72 0 0 1 .72.72V33.86a.72.72 0 0 1-.72.72H5.22a.72.72 0 0 1-.72-.72V6.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M6.22 6.014h40.56a.72.72 0 0 1 .72.72V33.86a.72.72 0 0 1-.72.72H6.22a.72.72 0 0 1-.72-.72V6.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M5.22 7.014h40.56a.72.72 0 0 1 .72.72V34.86a.72.72 0 0 1-.72.72H5.22a.72.72 0 0 1-.72-.72V7.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M5.22 6.014h40.56a.72.72 0 0 1 .72.72V33.86a.72.72 0 0 1-.72.72H5.22a.72.72 0 0 1-.72-.72V6.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M5.22 6.014h40.56a.72.72 0 0 1 .72.72V33.86a.72.72 0 0 1-.72.72H5.22a.72.72 0 0 1-.72-.72V6.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M5.22 7.014h40.56a.72.72 0 0 1 .72.72V34.86a.72.72 0 0 1-.72.72H5.22a.72.72 0 0 1-.72-.72V7.734a.72.72 0 0 1 .72-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M.72 0h153.06a.72.72 0 0 1 .72.72v27.126a.72.72 0 0 1-.72.72H.72a.72.72 0 0 1-.72-.72V.72A.72.72 0 0 1 .72 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(87 67.657)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M36 28.149c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.483 1.075 1.086v.835c0 .6-.492 1.086-1.075 1.086h-5.35A1.078 1.078 0 0 1 36 28.984v-.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M1.08.793a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V1.423a.63.63 0 0 0-.63-.63H1.08z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M91.5 6.014c0 .83-1.007 1.503-2.25 1.503S87 6.844 87 6.014c0-.83 1.007-1.504 2.25-1.504s2.25.674 2.25 1.504",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 162 25.948c0 5.598-4.538 10.136-10.136 10.136H7.136C1.538 36.084-3 31.546-3 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#d)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 16.372L30.98 20.75a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.044a13.05 13.05 0 0 1 8.113.703l13.148 5.618a13.05 13.05 0 0 0 7.327.864l6.843-1.17A8.55 8.55 0 0 1 165 24.445c0 5.598-4.538 10.135-10.136 10.135H10.136C4.538 34.58 0 30.043 0 24.445a8.245 8.245 0 0 1 9.923-8.073z",
    mask: "url(#d)",
    opacity: 0.3,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M7.5 15.185V9.771a.75.75 0 0 1 .92-.73.45.45 0 0 1 .58.43v10.074H7.5v-3.007H6.3a1.8 1.8 0 0 1-1.8-1.8v-1.81a.9.9 0 0 1 1.8 0v2.257h1.2z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2E7",
    d: "M41.1 15.072a.425.425 0 0 1 .6.39v2.583c0 .491-.236.927-.6 1.2v3.307h-1.5v-8.27a.75.75 0 0 1 1.5 0v.79zm-3.452 1.466c.248 0 .448.201.448.449v2.709h.604v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.562c0-.248.2-.449.448-.449z",
    mask: "url(#d)",
    transform: "matrix(-1 0 0 1 79.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M18 22.552V12.024a1.5 1.5 0 0 1 3 0v7.521h1.071V15.246a1.714 1.714 0 1 1 3.429 0v5.506a1.8 1.8 0 0 1-1.8 1.8H21v9.021h-3V25.56h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.72a1.5 1.5 0 0 1 3 0v4.513H18z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M70.3 18.343H72v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.6v9.02h-3V10.522a1.5 1.5 0 0 1 3 0v7.822zm-6.25-3.308c.746 0 1.35.604 1.35 1.35v4.965h1.8v2.706h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871c0-.746.604-1.35 1.35-1.35z",
    mask: "url(#d)",
    transform: "matrix(-1 0 0 1 138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M139.5 18.192v-5.414a.75.75 0 1 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v1.503h-1.5a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .9 0v2.707h.6z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M127.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#d)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.5 67.657)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M37 28.149c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.483 1.075 1.086v.835c0 .6-.492 1.086-1.075 1.086h-5.35A1.078 1.078 0 0 1 37 28.984v-.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M1.58.793a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V1.423a.63.63 0 0 0-.63-.63H1.58z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 6.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M93 6.766a2.253 2.253 0 0 1-2.25 2.255 2.253 2.253 0 0 1-2.25-2.255 2.253 2.253 0 0 1 2.25-2.256c1.243 0 2.25 1.01 2.25 2.256",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 162 25.948c0 5.598-4.538 10.136-10.136 10.136H7.136C1.538 36.084-3 31.546-3 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#h)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 14.869l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 165 22.941c0 5.598-4.538 10.136-10.136 10.136H10.136C4.538 33.077 0 28.539 0 22.94a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#h)",
    opacity: 0.2,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M6 12.257V9.771a.75.75 0 0 1 1.5 0v2.407h.6V9.471a.45.45 0 1 1 .9 0v2.56a1.5 1.5 0 0 1-1.5 1.5v6.014H6v-3.031a1.8 1.8 0 0 1-1.5-1.776v-1.81a.9.9 0 0 1 1.5-.67z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M23.325 13.531c.041 0 .075.034.075.075v8.946h-.15v-8.946c0-.041.034-.075.075-.075zm1.725 1.504a.45.45 0 0 1 .45.45v2.56a1.5 1.5 0 0 1-1.5 1.5v-1.353h.6v-2.707a.45.45 0 0 1 .45-.45zm-3.6 1.503a.45.45 0 0 1 .45.45v2.708h.6v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .45-.45z",
    mask: "url(#h)",
    transform: "matrix(-1 0 0 1 46.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M16.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M72 18.113V6.01a1.5 1.5 0 0 1 3 0v9.202h1.5V7.514a1.5 1.5 0 0 1 3 0v8.728a1.8 1.8 0 0 1-1.8 1.8H75v13.531h-3V21.05h-2.7a1.8 1.8 0 0 1-1.8-1.8v-8.728a1.5 1.5 0 0 1 3 0V18.042l1.5.07z",
    mask: "url(#h)",
    transform: "matrix(-1 0 0 1 147 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M139.5 18.192v-5.414a.75.75 0 1 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v1.503h-1.5a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .9 0v2.707h.6z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M127.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#h)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F2",
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M88.08 111.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33H88.08zM88.08 155.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33H88.08zM143.08 155.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33h-48.84zM198.08 155.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33h-48.84zM143.08 111.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33h-48.84zM198.08 111.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33v-36.84a.33.33 0 0 0-.33-.33h-48.84zM198.08 68.75a.33.33 0 0 0-.33.33v36.84c0 .182.148.33.33.33h48.84a.33.33 0 0 0 .33-.33V69.08a.33.33 0 0 0-.33-.33h-48.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F2",
    d: "M341.564 74.143c-.341 0-.684.017-1.033.05.07-.492.103-.98.103-1.462 0-6.114-5.07-11.088-11.302-11.088-5.654 0-10.36 4.022-11.176 9.445-2.906.6-10.557 2.124-13.386 5.687-1.54 1.938-2.549 4.392-3.027 7.363a1.8 1.8 0 0 0 1.777 2.087h46.687c.805 0 1.55-.367 2.043-1.004.5-.646.67-1.472.466-2.268-1.326-5.187-5.912-8.81-11.152-8.81zM56.613 101.858c-.482 0-.967.025-1.46.072.099-.696.147-1.386.147-2.066 0-8.64-7.165-15.668-15.971-15.668-7.99 0-14.64 5.683-15.793 13.346-4.107.849-14.918 3.002-18.916 8.035-2.33 2.935-3.801 6.708-4.41 11.318a1.8 1.8 0 0 0 1.784 2.036h66.833c1.137 0 2.19-.518 2.886-1.418.706-.913.946-2.08.659-3.205-1.875-7.33-8.354-12.45-15.759-12.45z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EEF0F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.8 52.99c-2.131-7.518-8.89-13.015-16.916-13.015-1.098 0-2.169.118-3.211.315.294-1.24.467-2.524.467-3.851 0-9.33-7.721-16.894-17.248-16.894-8.957 0-16.317 6.691-17.163 15.25-8.987 1.503-15.763 8.174-15.763 16.181 0 .048.009.095.009.143h4.489c3.567 0 6.515 2.685 6.95 6.145h55.122c2.223 0 3.872-2.13 3.264-4.273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.464 53.576H57.059c-2.514 0-4.559 2.05-4.559 4.571v3.15c0 2.52 2.045 4.57 4.559 4.57h15.405a4.57 4.57 0 0 0 4.56-4.57v-3.15a4.57 4.57 0 0 0-4.56-4.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#B8C1CA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226 91c.252 2.418 8.49 7.138 11 9 3.175-1.862 8.746-6.584 9-9l-8-11h-4l-8 11zm-1 0c0-.51.034-.614 0-1l8-11c.325.079.481 0 1 0h4c.481 0 .64.079 1 0l8 11c-.034.385 0 .49 0 1 0 3.268-8.418 9.248-9 10-.56-.028-.658 0-1 0-1.097-.752-12-6.732-12-10zM235 78.492V40.508c0-.28.448-.508 1-.508s1 .227 1 .508v37.984c0 .28-.448.508-1 .508s-1-.227-1-.508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 96c-.552 0-1-.237-1-.53V79.53c0-.293.448-.53 1-.53s1 .237 1 .53v15.94c0 .293-.448.53-1 .53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.775 77h4.45c.428 0 .775.289.775.646v1.708c0 .356-.347.646-.775.646h-4.45c-.427 0-.775-.29-.775-.646v-1.708c0-.357.348-.646.775-.646"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M331.941 33H316.06A1.06 1.06 0 0 0 315 34.062v14.875A1.06 1.06 0 0 0 316.059 50h15.882A1.06 1.06 0 0 0 333 48.937V34.062A1.06 1.06 0 0 0 331.941 33M229.28 26.425a.51.51 0 0 1-.204-.98L285.874.61a.51.51 0 0 1 .409.938l-56.798 24.834a.516.516 0 0 1-.204.043M291.827 64.828a.513.513 0 0 1-.457-.283l-12.753-25.567a.514.514 0 0 1 .229-.687.51.51 0 0 1 .685.229l12.753 25.566a.513.513 0 0 1-.457.742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 64.828a.513.513 0 0 1-.457-.742L291.37 38.52a.512.512 0 0 1 .914.458l-12.753 25.567a.513.513 0 0 1-.457.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M291.827 89.813a.513.513 0 0 1-.457-.283l-12.753-25.566a.51.51 0 1 1 .915-.459l12.752 25.566a.513.513 0 0 1-.457.742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 89.813a.513.513 0 0 1-.457-.742l12.753-25.566a.513.513 0 0 1 .914.459L279.531 89.53a.513.513 0 0 1-.457.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M291.827 115.185a.513.513 0 0 1-.457-.282l-12.753-25.566a.51.51 0 1 1 .915-.459l12.752 25.566a.513.513 0 0 1-.457.741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 115.185a.513.513 0 0 1-.457-.742l12.753-25.565a.513.513 0 0 1 .914.46l-12.753 25.565a.513.513 0 0 1-.457.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M291.827 140.17a.513.513 0 0 1-.457-.282l-12.753-25.566a.514.514 0 0 1 .229-.687.51.51 0 0 1 .685.228l12.753 25.566a.513.513 0 0 1-.457.741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 140.17a.513.513 0 0 1-.457-.742l12.753-25.565a.512.512 0 0 1 .914.46l-12.753 25.565a.513.513 0 0 1-.457.282"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M291.827 165.544a.513.513 0 0 1-.457-.283l-12.753-25.566a.511.511 0 1 1 .915-.459l12.752 25.566a.513.513 0 0 1-.457.742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 165.544a.513.513 0 0 1-.457-.742l12.753-25.566a.513.513 0 0 1 .914.459l-12.753 25.566a.513.513 0 0 1-.457.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M291.827 190.528a.513.513 0 0 1-.457-.283l-12.753-25.565a.514.514 0 0 1 .229-.687.509.509 0 0 1 .685.228l12.753 25.566a.513.513 0 0 1-.457.741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M279.074 190.528a.513.513 0 0 1-.457-.742l12.753-25.565a.51.51 0 1 1 .914.459l-12.753 25.565a.513.513 0 0 1-.457.283M285.052 39.406a1.022 1.022 0 0 1-1.021-1.024V1.51a1.022 1.022 0 1 1 2.043 0v36.872c0 .566-.456 1.024-1.022 1.024M268.08 25.624a.51.51 0 0 0-.722 0l-12.392 12.42-12.393-12.42a.51.51 0 0 0-.722 0l-12.392 12.42-12.39-12.417s0-.002-.002-.003a.508.508 0 0 0-.723 0l-.002.003-12.39 12.418-12.39-12.418s0-.002-.002-.003a.509.509 0 0 0-.723 0l-.002.003-12.39 12.418-12.392-12.42a.51.51 0 1 0-.722.723l12.753 12.784a.508.508 0 0 0 .723 0l12.393-12.42 12.391 12.42a.508.508 0 0 0 .723 0l12.392-12.42 12.392 12.42a.508.508 0 0 0 .723 0l12.392-12.421 12.391 12.42a.513.513 0 0 0 .724 0l12.752-12.783c.2-.2.2-.524 0-.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M245.048 36h-18.096c-.526 0-.952.51-.952 1.143v5.714c0 .632.426 1.143.952 1.143h18.096c.526 0 .952-.51.952-1.143v-5.714c0-.632-.426-1.143-.952-1.143M331.548 33.985a.505.505 0 0 1-.296-.095l-45.47-32.394a.512.512 0 0 1 .593-.834l45.47 32.394a.512.512 0 0 1-.297.929"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M279.001 199.184h12.056V29.345l-6-23.12L279 29.345v169.839zm-.08 2.048c-.565 0-1.896-.457-1.896-1.024-.01-114.37-.01-171.58 0-171.628l7.034-27.314a1.022 1.022 0 1 1 1.996.001l6.762 27.28c.01.048.07 57.268.178 171.661 0 .567-1.246 1.024-1.812 1.024h-12.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M153.34 40.324a1.078 1.078 0 0 1-.078-1.49L164.53 25.91c.195-.224.472-.921.763-.921h102.561c.285 0 .763.493.956.708l11.418 13.124c.384.428.36 1.096-.055 1.491a1.002 1.002 0 0 1-1.448-.056l-11.307-13.285-101.497.084-11.134 13.189a1.005 1.005 0 0 1-1.446.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M154 41h179v-2H154zM292 70c0-.386-.065-.25 0 0-.265-.06-.397 0 0 0h-11c.243 0 0-.241 0 0V56c0 .241.243 0 0 0h11c-.397 0-.265.06 0 0-.065.25 0 .386 0 0v14zm-20 0V56c0 .266.216.05 0 0 .517.01.54 0 0 0h5c-.28 0 0 .24 0 0v14c0-.241-.28 0 0 0h-5c.54 0 .517-.01 0 0 .216-.05 0-.267 0 0zm19-19h-19c-1.533 0-2 .465-2 2v16c0 1.283.085 1.517 0 2l5 6c.338-.14.634 0 1 0h15c1.532 0 2-.465 2-2V53c0-1.535-.468-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M282.065 67.96h8.253V56.692h-8.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M291.028 55.835a.501.501 0 0 0-.352-.146h-9.2c-.282 0-.511.23-.511.512v12.29c0 .285.229.513.51.513h9.201a.51.51 0 0 0 .507-.512v-12.29a.51.51 0 0 0-.155-.367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M271 201h28v-12h-28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(210 89.21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M36 27.645c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.484 1.075 1.086v.836c0 .6-.492 1.085-1.075 1.085h-5.35A1.078 1.078 0 0 1 36 28.481v-.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M1.08 1.24a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V1.87a.63.63 0 0 0-.63-.63H1.08z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 7.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M120 7.747V5.26a.75.75 0 1 1 1.5 0v3.911h1.2V6.914a.9.9 0 0 1 1.8 0v1.81a1.8 1.8 0 0 1-1.8 1.8h-1.2v4.511H120v-3.032a1.8 1.8 0 0 1-1.5-1.775v-1.81a.9.9 0 0 1 1.5-.671z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M91.5 6.014c0 .83-1.007 1.503-2.25 1.503S87 6.844 87 6.014c0-.83 1.007-1.504 2.25-1.504s2.25.674 2.25 1.504",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 16.372L27.98 20.75a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.044a13.05 13.05 0 0 1 8.113.703l13.148 5.618a13.05 13.05 0 0 0 7.327.864l6.843-1.17A8.55 8.55 0 0 1 162 24.445c0 5.598-4.538 10.135-10.136 10.135H7.136C1.538 34.58-3 30.043-3 24.445a8.245 8.245 0 0 1 9.923-8.073z",
    mask: "url(#l)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 165 25.948c0 5.598-4.538 10.136-10.136 10.136H10.136C4.538 36.084 0 31.546 0 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#l)",
    opacity: 0.3,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M6 12.257V9.771a.75.75 0 0 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v4.51H6v-3.031a1.8 1.8 0 0 1-1.5-1.776v-1.81a.9.9 0 0 1 1.5-.67z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M23.325 13.531c.041 0 .075.034.075.075v8.946h-.15v-8.946c0-.041.034-.075.075-.075zm1.725 1.504a.45.45 0 0 1 .45.45v2.56a1.5 1.5 0 0 1-1.5 1.5v-1.353h.6v-2.707a.45.45 0 0 1 .45-.45zm-3.6 1.503a.45.45 0 0 1 .45.45v2.708h.6v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .45-.45z",
    mask: "url(#l)",
    transform: "matrix(-1 0 0 1 46.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M16.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M70.3 18.343H72v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.6v9.02h-3V10.522a1.5 1.5 0 0 1 3 0v7.822zm-6.25-3.308c.746 0 1.35.604 1.35 1.35v4.965h1.8v2.706h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871c0-.746.604-1.35 1.35-1.35z",
    mask: "url(#l)",
    transform: "matrix(-1 0 0 1 138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M136.5 22.552V10.521a1.5 1.5 0 0 1 3 0v9.024h1.071V12.24a1.714 1.714 0 1 1 3.429 0v8.513a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.021h-3V25.56h-2.7a1.8 1.8 0 0 1-1.8-1.8v-8.728a1.5 1.5 0 0 1 3 0v7.521h1.5z",
    mask: "url(#l)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(177 162.378)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M36 26.645c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.484 1.075 1.086v.836c0 .6-.492 1.085-1.075 1.085h-5.35A1.078 1.078 0 0 1 36 27.481v-.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M1.08.072a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V.702a.63.63 0 0 0-.63-.63H1.08z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 6.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M120 7.747V5.26a.75.75 0 1 1 1.5 0v3.911h1.2V6.914a.9.9 0 0 1 1.8 0v1.81a1.8 1.8 0 0 1-1.8 1.8h-1.2v4.511H120v-3.032a1.8 1.8 0 0 1-1.5-1.775v-1.81a.9.9 0 0 1 1.5-.671z",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M91.5 6.014c0 .83-1.007 1.503-2.25 1.503S87 6.844 87 6.014c0-.83 1.007-1.504 2.25-1.504s2.25.674 2.25 1.504",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 16.372L27.98 20.75a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.044a13.05 13.05 0 0 1 8.113.703l13.148 5.618a13.05 13.05 0 0 0 7.327.864l6.843-1.17A8.55 8.55 0 0 1 162 24.445c0 5.598-4.538 10.135-10.136 10.135H7.136C1.538 34.58-3 30.043-3 24.445a8.245 8.245 0 0 1 9.923-8.073z",
    mask: "url(#p)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 165 25.948c0 5.598-4.538 10.136-10.136 10.136H10.136C4.538 36.084 0 31.546 0 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#p)",
    opacity: 0.3,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M6 12.257V9.771a.75.75 0 0 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v4.51H6v-3.031a1.8 1.8 0 0 1-1.5-1.776v-1.81a.9.9 0 0 1 1.5-.67z",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M23.325 13.531c.041 0 .075.034.075.075v8.946h-.15v-8.946c0-.041.034-.075.075-.075zm1.725 1.504a.45.45 0 0 1 .45.45v2.56a1.5 1.5 0 0 1-1.5 1.5v-1.353h.6v-2.707a.45.45 0 0 1 .45-.45zm-3.6 1.503a.45.45 0 0 1 .45.45v2.708h.6v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .45-.45z",
    mask: "url(#p)",
    transform: "matrix(-1 0 0 1 46.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M16.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M70.3 18.343H72v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.6v9.02h-3V10.522a1.5 1.5 0 0 1 3 0v7.822zm-6.25-3.308c.746 0 1.35.604 1.35 1.35v4.965h1.8v2.706h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871c0-.746.604-1.35 1.35-1.35z",
    mask: "url(#p)",
    transform: "matrix(-1 0 0 1 138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M136.5 22.552V10.521a1.5 1.5 0 0 1 3 0v9.024h1.071V12.24a1.714 1.714 0 1 1 3.429 0v8.513a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.021h-3V25.56h-2.7a1.8 1.8 0 0 1-1.8-1.8v-8.728a1.5 1.5 0 0 1 3 0v7.521h1.5z",
    mask: "url(#p)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.5 165.888)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M36 26.645c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.484 1.075 1.086v.836c0 .6-.492 1.085-1.075 1.085h-5.35A1.078 1.078 0 0 1 36 27.481v-.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M.58.562a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V1.192a.63.63 0 0 0-.63-.63H.58z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 6.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M120 7.747V5.26a.75.75 0 1 1 1.5 0v3.911h1.2V6.914a.9.9 0 0 1 1.8 0v1.81a1.8 1.8 0 0 1-1.8 1.8h-1.2v4.511H120v-3.032a1.8 1.8 0 0 1-1.5-1.775v-1.81a.9.9 0 0 1 1.5-.671z",
    mask: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M91.5 6.014c0 .83-1.007 1.503-2.25 1.503S87 6.844 87 6.014c0-.83 1.007-1.504 2.25-1.504s2.25.674 2.25 1.504",
    mask: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 16.372L27.98 20.75a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.044a13.05 13.05 0 0 1 8.113.703l13.148 5.618a13.05 13.05 0 0 0 7.327.864l6.843-1.17A8.55 8.55 0 0 1 162 24.445c0 5.598-4.538 10.135-10.136 10.135H7.136C1.538 34.58-3 30.043-3 24.445a8.245 8.245 0 0 1 9.923-8.073z",
    mask: "url(#t)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 165 25.948c0 5.598-4.538 10.136-10.136 10.136H10.136C4.538 36.084 0 31.546 0 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#t)",
    opacity: 0.3,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M6 12.257V9.771a.75.75 0 0 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v4.51H6v-3.031a1.8 1.8 0 0 1-1.5-1.776v-1.81a.9.9 0 0 1 1.5-.67z",
    mask: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M23.325 13.531c.041 0 .075.034.075.075v8.946h-.15v-8.946c0-.041.034-.075.075-.075zm1.725 1.504a.45.45 0 0 1 .45.45v2.56a1.5 1.5 0 0 1-1.5 1.5v-1.353h.6v-2.707a.45.45 0 0 1 .45-.45zm-3.6 1.503a.45.45 0 0 1 .45.45v2.708h.6v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .45-.45z",
    mask: "url(#t)",
    transform: "matrix(-1 0 0 1 46.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M16.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M70.3 18.343H72v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.6v9.02h-3V10.522a1.5 1.5 0 0 1 3 0v7.822zm-6.25-3.308c.746 0 1.35.604 1.35 1.35v4.965h1.8v2.706h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871c0-.746.604-1.35 1.35-1.35z",
    mask: "url(#t)",
    transform: "matrix(-1 0 0 1 138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M136.5 22.552V10.521a1.5 1.5 0 0 1 3 0v9.024h1.071V12.24a1.714 1.714 0 1 1 3.429 0v8.513a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.021h-3V25.56h-2.7a1.8 1.8 0 0 1-1.8-1.8v-8.728a1.5 1.5 0 0 1 3 0v7.521h1.5z",
    mask: "url(#t)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169 169.399)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#84BBF9",
    d: "M36 27.645c0-.6.492-1.086 1.075-1.086h5.35c.594 0 1.075.484 1.075 1.086v.836c0 .6-.492 1.085-1.075 1.085h-5.35A1.078 1.078 0 0 1 36 28.481v-.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B8C1CA",
    strokeWidth: 0.9,
    d: "M1.08 1.051a.63.63 0 0 0-.63.63v36.84c0 .348.282.63.63.63h48.84a.63.63 0 0 0 .63-.63V1.681a.63.63 0 0 0-.63-.63H1.08z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 7.014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M91.5 6.014c0 .83-1.007 1.503-2.25 1.503S87 6.844 87 6.014c0-.83 1.007-1.504 2.25-1.504s2.25.674 2.25 1.504",
    mask: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M6.923 16.372L27.98 20.75a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.044a13.05 13.05 0 0 1 8.113.703l13.148 5.618a13.05 13.05 0 0 0 7.327.864l6.843-1.17A8.55 8.55 0 0 1 162 24.445c0 5.598-4.538 10.135-10.136 10.135H7.136C1.538 34.58-3 30.043-3 24.445a8.245 8.245 0 0 1 9.923-8.073z",
    mask: "url(#x)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M9.923 17.876l21.056 4.377a13.05 13.05 0 0 0 5.847-.123l22.103-5.574a13.05 13.05 0 0 1 5.918-.108l14.79 3.16a13.05 13.05 0 0 0 5.713-.058l34.228-8.045a13.05 13.05 0 0 1 8.113.704l13.148 5.618a13.05 13.05 0 0 0 7.327.863l6.843-1.17A8.55 8.55 0 0 1 165 25.948c0 5.598-4.538 10.136-10.136 10.136H10.136C4.538 36.084 0 31.546 0 25.948a8.245 8.245 0 0 1 9.923-8.072z",
    mask: "url(#x)",
    opacity: 0.3,
    transform: "matrix(-1 0 0 1 165 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M6 12.257V9.771a.75.75 0 0 1 1.5 0v3.91h.6v-2.707a.45.45 0 0 1 .9 0v2.561a1.5 1.5 0 0 1-1.5 1.5v4.51H6v-3.031a1.8 1.8 0 0 1-1.5-1.776v-1.81a.9.9 0 0 1 1.5-.67z",
    mask: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E8EB",
    d: "M23.325 13.531c.041 0 .075.034.075.075v8.946h-.15v-8.946c0-.041.034-.075.075-.075zm1.725 1.504a.45.45 0 0 1 .45.45v2.56a1.5 1.5 0 0 1-1.5 1.5v-1.353h.6v-2.707a.45.45 0 0 1 .45-.45zm-3.6 1.503a.45.45 0 0 1 .45.45v2.708h.6v1.353a1.5 1.5 0 0 1-1.5-1.5v-2.56a.45.45 0 0 1 .45-.45z",
    mask: "url(#x)",
    transform: "matrix(-1 0 0 1 46.5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M16.5 21.35V10.52a1.5 1.5 0 0 1 3 0v7.822h1.8v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.7v9.02h-3v-6.013h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871a1.35 1.35 0 0 1 2.7 0v4.965h1.8z",
    mask: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D9DF",
    d: "M70.3 18.343H72v-4.965a1.35 1.35 0 0 1 2.7 0v5.871a1.8 1.8 0 0 1-1.8 1.8h-2.6v9.02h-3V10.522a1.5 1.5 0 0 1 3 0v7.822zm-6.25-3.308c.746 0 1.35.604 1.35 1.35v4.965h1.8v2.706h-2.7a1.8 1.8 0 0 1-1.8-1.8v-5.871c0-.746.604-1.35 1.35-1.35z",
    mask: "url(#x)",
    transform: "matrix(-1 0 0 1 138 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CA",
    d: "M123 22.552V10.521a1.5 1.5 0 0 1 3 0v9.024h1.071V12.24a1.714 1.714 0 1 1 3.429 0v8.513a1.8 1.8 0 0 1-1.8 1.8H126v9.021h-3V25.56h-2.7a1.8 1.8 0 0 1-1.8-1.8v-8.728a1.5 1.5 0 0 1 3 0v7.521h1.5z",
    mask: "url(#x)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/workInProgress.0e63c22f25d2cb15a26d68b10858d9e7.svg";
export { ForwardRef as ReactComponent };